const prefix = 'page-header';
export const dataHooks = {
    breadcrumbs: `${prefix}-breadcrumbs`,
    backButton: `${prefix}-backbutton`,
    title: `${prefix}-title`,
    subtitle: `${prefix}-subtitle`,
    actionBar: `${prefix}-actionbar`,
};
//# sourceMappingURL=constants.js.map